/**
 * Registry that prevents key collisions between different logical storages.
 * Ensures that no two storages use the same key for the same storage type.
 */
const storageKeyRegistry = {
  registry: new Set(),

  /**
   * Registers a key for a given storage type.
   * Throws if the key/type pair is already registered, preventing collisions.
   *
   * @param {string} key The key to register.
   * @param {HASHMAP_STORAGE_TYPE} type The storage type.
   */
  registerKey(key, type) {
    if (this.isKeyRegistered(key, type)) {
      throw new TypeError(
        `Key '${key}' is already registered for storage type '${type}'`
      );
    }
    this.registry.add(this.composeKeySignature(key, type));
  },

  /**
   * Creates a unique signature for a key/type pair.
   *
   * @param {string} key The key
   * @param {string} type The type of storage
   * @returns {string} The composed signature.
   */
  composeKeySignature(key, type) {
    return `T${type}_K${key}`;
  },

  /**
   * Checks whether a key/type pair is already registered.
   *
   * @param {string} key The key
   * @param {string} type The type of storage
   * @returns {boolean} True if already registered.
   */
  isKeyRegistered(key, type) {
    return this.registry.has(this.composeKeySignature(key, type));
  },
};

module.exports = storageKeyRegistry;
